import { FileText } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function DocumentsPage() {
  return (
    <PhaseStubPage
      title="Document control"
      phase={5}
      modules={[
        'Document master with auto-numbering (SOP-DEPT-NNN)',
        'Versioned PDF storage in Supabase Storage',
        'Two-approver workflow before status → effective',
        'Required-reader role mapping → training assignments',
      ]}
      icon={FileText}
    />
  );
}
